import { Search, X } from "lucide-react";
import React from "react";
import { Input } from "../ui/input";
import { LanguageProviderContext } from "@/providers/LanguageProvider";
import { Button } from "../ui/button";

interface ClientsSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  resultCount: number;
  clearSearch: () => void;
}

const ClientsSearchBar: React.FC<ClientsSearchProps> = ({
  searchTerm,
  setSearchTerm,
  clearSearch,
}) => {
  const { translator } = React.useContext(LanguageProviderContext);
  return (
    <div className="flex items-center space-x-2">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder={translator('Clients.searchClientPlaceholder')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10 pr-10"
        />
        {searchTerm && (
          <Button
            variant="ghost"
            size="sm"
            aria-label={translator("Global.clearSearch")}
            onClick={clearSearch}
            className="absolute right-1 top-1/2 transform -translate-y-1/2 h-6 w-6 p-0"
          >
            <X className="h-3 w-3" /> 
          </Button>
        )}
      </div>
    </div>
  );
};

export default ClientsSearchBar;